import {
  ClipboardList,
  BadgeIndianRupee,
  Settings,
  ReceiptText,
  CalendarClock,
  WalletCards,
  UsersRound,
  SlidersHorizontal,
  Clock3,
  TimerReset,
  Landmark,
} from "lucide-react";

/**
 * Payroll hub — derived from schoolNavData "PAYROLL" category.
 *
 * All /staff-panel/... payroll routes in App.js are gated behind
 * ModuleGuard moduleCode="PAYROLL_MANAGEMENT".
 *
 * List/detail pages use PAYROLL_MANAGEMENT_VIEW;
 * create/edit-only actions use PAYROLL_MANAGEMENT_FULL.
 *
 * This hub only lists the VIEW-level entry points.
 * FULL-only create routes remain actions inside the relevant list pages.
 *
 * Icons are Lucide components and are rendered through the shared
 * HubIcon component by HubGrid.
 */
export const hubPayrollLinks = [
  {
    sectionTitle: "Payroll Processing",
    sectionIcon: ClipboardList,
    links: [
      {
        label: "Payroll Runs",
        url: "/payroll-runs",
        desc: "Process & review monthly runs",
        module: "PAYROLL_MANAGEMENT",
        permission: "PAYROLL_MANAGEMENT_VIEW",
        icon: ReceiptText,
      },
      {
        label: "Year-end Summary",
        url: "/payroll-year-end",
        desc: "Annual payroll rollup",
        module: "PAYROLL_MANAGEMENT",
        permission: "PAYROLL_MANAGEMENT_VIEW",
        icon: CalendarClock,
      },
    ],
  },

  {
    sectionTitle: "Salary Configuration",
    sectionIcon: BadgeIndianRupee,
    links: [
      {
        label: "Salary Components",
        url: "/salary-components",
        desc: "Earnings & deduction heads",
        module: "PAYROLL_MANAGEMENT",
        permission: "PAYROLL_MANAGEMENT_VIEW",
        icon: WalletCards,
      },
      {
        label: "Salary Structures",
        url: "/salary-structures",
        desc: "Component templates per staff",
        module: "PAYROLL_MANAGEMENT",
        permission: "PAYROLL_MANAGEMENT_VIEW",
        icon: SlidersHorizontal,
      },
      {
        label: "Role Salaries",
        url: "/role-salaries",
        desc: "Default salary by role",
        module: "PAYROLL_MANAGEMENT",
        permission: "PAYROLL_MANAGEMENT_VIEW",
        icon: UsersRound,
      },
    ],
  },

  {
    sectionTitle: "Payroll Configuration",
    sectionIcon: Settings,
    links: [
      {
        label: "Payroll Settings",
        url: "/payroll-settings",
        desc: "General payroll behavior",
        module: "PAYROLL_MANAGEMENT",
        permission: "PAYROLL_MANAGEMENT_VIEW",
        icon: Settings,
      },
      {
        label: "Pay Periods",
        url: "/pay-periods",
        desc: "Define pay cycles",
        module: "PAYROLL_MANAGEMENT",
        permission: "PAYROLL_MANAGEMENT_VIEW",
        icon: CalendarClock,
      },
      {
        label: "Shift Rules",
        url: "/shift-rules",
        desc: "Shift timing & rules",
        module: "PAYROLL_MANAGEMENT",
        permission: "PAYROLL_MANAGEMENT_VIEW",
        icon: Clock3,
      },
      {
        label: "Overtime Rules",
        url: "/overtime-rules",
        desc: "OT calculation rules",
        module: "PAYROLL_MANAGEMENT",
        permission: "PAYROLL_MANAGEMENT_VIEW",
        icon: TimerReset,
      },
      {
        label: "Statutory Config",
        url: "/statutory-config",
        desc: "PF, ESI, TDS settings",
        module: "PAYROLL_MANAGEMENT",
        permission: "PAYROLL_MANAGEMENT_VIEW",
        icon: Landmark,
      },
      {
        label: "Bank Accounts",
        url: "/bank-accounts",
        desc: "Staff bank accounts for payout",
        module: "PAYROLL_MANAGEMENT",
        permission: "PAYROLL_MANAGEMENT_VIEW",
        icon: WalletCards,
      },
    ],
  },
];

export default hubPayrollLinks;